const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 14%' },
    { key: 'remote_addr', label: 'Attacker', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: 'Risk', sortable: false, thStyle: 'width: 10%' },
    { key: 'message', label: 'Message', sortable: false },
    { key: 'ruleid', label: 'RuleID', sortable: false },
    { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 15%' },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '일시', sortable: false, thStyle: 'width: 14%' },
    { key: 'remote_addr', label: '공격자', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: '위험도', sortable: false, thStyle: 'width: 10%' },
    { key: 'message', label: '설명', sortable: false },
    { key: 'ruleid', label: '정책 ID', sortable: false },
    { key: 'is_block', label: '대응', sortable: false, thStyle: 'width: 15%' },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '日付/時刻', sortable: false, thStyle: 'width: 14%' },
    { key: 'remote_addr', label: '攻撃者', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: 'リスク', sortable: false, thStyle: 'width: 10%' },
    { key: 'message', label: 'メッセージ', sortable: false },
    { key: 'ruleid', label: 'ルールID', sortable: false },
    { key: 'is_block', label: '応答', sortable: false, thStyle: 'width: 15%' },
  ]
};

const _changed_fields = {
  EN : [
    { key : 'key', label: 'PolicyID', thStyle: 'width: 10%' },
    { key : 'desc', label: 'Message', },
    { key : 'level', label: 'Level', thStyle: 'width: 10%' },
    { key : 'severity', label: 'Risk', thStyle: 'width: 10%' },
    { key: 'use', label: 'Status', thStyle: 'width: 15%' },
    { key: 'mode', label: 'Mode', thStyle: 'width: 15%' },
  ],
  KO : [
    { key : 'key', label: '정책ID', thStyle: 'width: 10%' },
    { key : 'desc', label: '정책명', },
    { key : 'level', label: '레벨', thStyle: 'width: 10%' },
    { key : 'severity', label: '위험도', thStyle: 'width: 10%' },
    { key: 'use', label: '상태', thStyle: 'width: 15%' },
    { key: 'mode', label: '모드', thStyle: 'width: 15%' },
  ],
  JP : [
    { key : 'key', label: 'ポリシーID', thStyle: 'width: 10%' },
    { key : 'desc', label: 'メッセージ', },
    { key : 'level', label: 'レベル', thStyle: 'width: 10%' },
    { key : 'severity', label: 'リスク', thStyle: 'width: 10%' },
    { key: 'use', label: 'ステータス', thStyle: 'width: 15%' },
    { key: 'mode', label: 'モード', thStyle: 'width: 15%' },
  ]
}

const _i18n_info = {
  change_target : {
    EN: `changed webcastle`,
    KO: `changed webcastle`,
    JP: `webcastleを変更しました`
  }
}

const _i18n_success = {
  download : {
    EN: `request download`,
    KO: `request download`,
    JP: `ダウンロードをリクエストする`
  }
}

const _i18n_warning = {
  policy_save : {
    EN: `There's a policy that hasn't been saved. Please save it.`,
    KO: `There's a policy that hasn't been saved. Please save it.`,
    JP: `保存されていないポリシーがあります。 保存してください。`
  },
  domain_manage : {
    EN: `Typing plz domain on server`,
    KO: `Typing plz domain on server`,
    JP: `サーバー上でドメインを入力してください`
  },
  domain_manage_2 : {
    EN: `required!`,
    KO: `required!`,
    JP: `必須`
  },
  domain_manage_3 : {
    EN: `Typing plz only domain, not include protocol`,
    KO: `Typing plz only domain, not include protocol`,
    JP: `ドメインのみを入力し、プロトコルは含めません`
  }
}

const _i18n_error = {
  domain_failed : {
    EN: `domain_manage_regist failed`,
    KO: `domain_manage_regist failed`,
    JP: `Domain_manage_regist が失敗しました`
  },
  agent_failed : {
    EN: `agent load failed`,
    KO: `agent load failed`,
    JP: `エージェントのロードに失敗しました`
  }
}

const _i18n_data = {
  i18n_fields,
  _changed_fields,
  _i18n_info,
  _i18n_success,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data